module.exports = __webpack_public_path__ + "static/browse-with-brave-b4e4853ffd9bf528cbfa18f60b942568.png";